import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { sanitize } from "../../utils/functions"
import "./_corporate.scss"

import Layout from "§/src/components/layout"
import BreadcrumbCustomLevels from "§/src/components/atoms/breadcrumb/breadcrumb-customlevels"
import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"

// Internals
import { isEmpty } from "lodash"
import AccordionGroup from "§/src/components/sections/accordion-group/accordion"
import AccordionGroupItemPeople from "§/src/components/sections/accordion-group/accordion-item-people"
import PeopleGrid from "§/src/components/sections/people-grid"
import TileContentDownloads from "../../components/atoms/content/tile-content-downloads"

// Switch Language
import { useTranslation } from "react-i18next"
import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="temp-governance-corporate is-theme-dark"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations} />
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
    </React.Fragment>
  )
}

const TemplateGovernanceCorporate = props => {
  const { t } = useTranslation()
  const data = props?.pageContext?.acfPages_gov_corporate

  const downloadFile = async (fileUrl, fileName) => {
    if (fileUrl) {
      let alink = document.createElement("a")
      alink.href = fileUrl
      alink.download = fileName
      alink.target = "_blank"
      alink.click()
    }
  }

  useEffect(() => {
    setTimeout(function () {
      const urlParams = new URLSearchParams(window.location.search)
      const accordionLink = urlParams.get("link")
      if (accordionLink) {
        const accordionButton = document
          .getElementById(accordionLink)
          .previousSibling.querySelector("button")
        accordionButton.click()
      }
    }, 500)
  }, [])

  return (
    <Layout lang={props?.data?.lang?.translations} className={"is-theme-dark"}>
      <BreadcrumbCustomLevels
        levels="1"
        wpseo={props?.pageContext?.seo?.breadcrumbs}
        base={t("Investor relations")}
        className="dark-crumbs no-links mb-0"
      />

      {!isEmpty(props?.pageContext) ? (
        <React.Suspense fallback={<LoadingFrame />}>
          <div className="bg-full bg-header g-100 pt-4 pb-6 mb-5 mb-md-7">
            <h1 className="fs-30 text-white m-0">
              {props?.pageContext?.title}
            </h1>
          </div>
          {data.corporate && (
            <AccordionGroup index={"accordion-1"}>
              {data?.corporate.map((item, index) => (
                <AccordionGroupItemPeople
                  key={"item-" + index}
                  parentindex={"accordion-1"}
                  itemindex={"item-" + index}
                  title={item?.title}
                >
                  <div className="d-flex flex-column gap-5 gap-md-7">
                    {item?.content && (
                      <div
                        className="content fs-14 m-0 col-11"
                        dangerouslySetInnerHTML={{
                          __html: sanitize(item?.content),
                        }}
                      />
                    )}
                    {item?.personsGroup &&
                      item?.personsGroup?.map((personsGroup, index) => (
                        <div
                          key={"people-group-" + index}
                          className="d-flex flex-column gap-5 gap-md-7"
                        >
                          {personsGroup?.persons && (
                            <PeopleGrid
                              key={"people-grid-" + index}
                              title={personsGroup?.personsTitle}
                              items={personsGroup?.persons}
                            />
                          )}
                          {personsGroup?.downloadFiles && (
                            <TileContentDownloads
                              downloadstitle={personsGroup?.downloadsTitle}
                              downloadsfiles={translateToNewFormat(
                                personsGroup?.downloadFiles
                              )}
                              ondownload={downloadFile}
                            />
                          )}
                        </div>
                      ))}
                  </div>
                </AccordionGroupItemPeople>
              ))}
            </AccordionGroup>
          )}
        </React.Suspense>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}

export default TemplateGovernanceCorporate

export const pageQuery = graphql`
  query GET_TRANSLATIONS($eq: String!) {
    lang: wpPage(slug: { eq: $eq }) {
      translations {
        postUrl
        siteId
      }
    }
  }
`

const translateToNewFormat = data => {
  data = (data || []).map(x => ({
    title: x.title,
    fieldGroupName: x.fieldGroupName,
    files: [{ ...x.file, title: x.title }],
    file: { ...x.file, title: x.title },
  }))

  return data
}
